import { timestampDate } from '@bufbuild/protobuf/wkt'
import _ from 'lodash'

import { DocumentSource } from '@/gen/artifacts/v1/model_pb'

import { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

import type { Group } from '@/components/lemmala-design-system/table/types'

// Sorting function for artifacts: expiry first, then date added
const compareByExpirationAndDateAdded = (a: ArtifactRow, b: ArtifactRow) => {
  if (a.expirationDate && b.expirationDate) {
    return timestampDate(b.expirationDate).getTime() - timestampDate(a.expirationDate).getTime()
  } else if (a.expirationDate) {
    return -1
  } else if (b.expirationDate) {
    return 1
  } else if (a.dateAdded && b.dateAdded) {
    return timestampDate(b.dateAdded).getTime() - timestampDate(a.dateAdded).getTime()
  } else {
    return b.id.localeCompare(a.id)
  }
}

export function groupArtifactsByVersion(data: ArtifactRow[]): Group<ArtifactRow>[] {
  const sortedData = [...data].sort(compareByExpirationAndDateAdded)

  const firstVersionItems = _.uniqBy(sortedData, (item) =>
    item.source === DocumentSource.WEB || item.artifactSubcategory?.endsWith('Questionnaire')
      ? item.id
      : item.artifactSubcategory || item.id,
  )

  const groupedData = _.groupBy(
    sortedData.filter(
      (item) =>
        !firstVersionItems.some((unique) => unique.id === item.id) &&
        item.source !== DocumentSource.WEB,
    ),
    'artifactSubcategory',
  )

  return firstVersionItems.map((artifact) => {
    const subcategory = artifact.artifactSubcategory
    const previousVersions = subcategory ? groupedData[subcategory] || [] : []
    return {
      parent: artifact,
      children: previousVersions,
    }
  })
}
